/**
 * EventBus - Vue3 事件总线
 * 用于组件间通信
 */

class EventBus {
  constructor() {
    // 存储事件及其对应的监听器
    this.events = {};
  }

  /**
   * 监听事件
   * @param {string} event - 事件名
   * @param {Function} callback - 回调函数
   */
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  /**
   * 监听事件（只触发一次）
   * @param {string} event - 事件名
   * @param {Function} callback - 回调函数
   */
  once(event, callback) {
    const onceWrapper = (...args) => {
      callback(...args);
      this.off(event, onceWrapper);
    };
    this.on(event, onceWrapper);
  }

  /**
   * 触发事件
   * @param {string} event - 事件名
   * @param  {...any} args - 传递的参数
   */
  emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach((callback) => {
        callback(...args);
      });
    }
  }

  /**
   * 移除事件监听
   * @param {string} event - 事件名
   * @param {Function} callback - 要移除的回调函数（可选）
   */
  off(event, callback) {
    if (!this.events[event]) return;

    if (callback) {
      // 移除特定的回调函数
      this.events[event] = this.events[event].filter((cb) => cb !== callback);
    } else {
      // 移除所有回调函数
      delete this.events[event];
    }
  }

  /**
   * 清空所有事件监听
   */
  clear() {
    this.events = {};
  }
}

// 导出单例
export default new EventBus();
